export const environment = {
  production: true,
  baseUrl: 'https://preprod.api.bureau401.fr'
};
